import React, { useState, useEffect, useContext } from 'react';
import markerSDK from '@marker.io/browser';

import { AdminContext } from '../../contexts/admin.context';

import bug from '../../assets/logos/svgLogos/bug.svg';

const BugReport = () => {
  const [widget, setWidget] = useState(null);

  const { user } = useContext(AdminContext);

  useEffect(() => {
    (async () => {
      const w = await markerSDK.loadWidget({ project: '6627bb5eda4e87158598e41b' });
      w.hide();
      w.on('show', function listener() {
        w.hide();
      });
      setWidget(w);
    })();
  }, []);

  useEffect(() => {
    if (user && widget) {
      widget.setReporter({
        email: user?.id,
        fullName: `${user?.firstname} ${user?.lastname}`
      });
    }
  }, [user, widget]);

  if (!widget) return null;

  return (
    <button className="fixed bottom-4 right-4 z-50 w-12 h-12 cursor-pointer outline-none">
      <img src={bug} alt="bug" onClick={() => widget?.capture('advanced')} />
    </button>
  );
};

export default BugReport;
